import {Pipe, PipeTransform} from '@angular/core';

// Humanizes a permission id (e.g. 'CanAccessFinances' -> 'Can Access Finances').
// Keeping the label derived from the id means a newly added backend permission
// shows up in the UI without any frontend change.
@Pipe({name: 'permissionLabel', standalone: true})
export class PermissionLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/^./, c => c.toUpperCase());
  }
}
